import React from "react";

export const GlassCard = React.forwardRef(function GlassCard(
  { className = "", children, hover = false, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={`pdg-glass rounded-2xl ${hover ? "hover:border-[hsl(var(--pdg-gold)/0.35)] transition-colors duration-200" : ""} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
});
